//Variables
(function () {

	let modalButtons = Array.from(document.querySelectorAll('[data-name-modal]'));
	let spans = Array.from(document.getElementsByClassName('close'));
	let modals = Array.from(document.querySelectorAll('.modal'));
	let modalContent = Array.from(document.querySelectorAll('.modal-content'));

	const modalClickHandler = (modal) => {
		console.log('clicked');
		let selectedModal = document.querySelector(`[data-name=${modal}]`);
		selectedModal.style.display = 'block';
	};

	const spanClickHandler = (modal) => {
		console.log('Span Clicked');
		let selectedModal = document.querySelector(`[data-name=${modal}]`);
		selectedModal.style.display = 'none';
	};

	modalButtons.forEach((button) => {
		button.addEventListener('click', () => {
			modalClickHandler(button.getAttribute('data-name-modal'));
		});
	});

	spans.forEach((button) => {
		button.addEventListener('click', () => {
			spanClickHandler(button.getAttribute('data-close'));
		});
	});

	modals.forEach((modal) => {
		modal.addEventListener('click', () => {
			modal.style.display = 'none';
		});
	});

	modalContent.forEach((modal) => {
		modal.addEventListener('click', () => {
			event.stopPropagation();
		});
	});
})();
